/**
 * Question-set panel layout: normalize legacy values for player and defaults.
 */

import type { QuestionSetLayoutConfig } from './schema';

export type QuestionSetPanelArrangement = 'horizontal' | 'vertical';

/**
 * Resolve stored layout type for question-set.
 * Legacy `auto` (and unknown values) become `horizontal`.
 * Note: `horizontal` is responsive — player stacks page vs questions on small viewports.
 */
export function normalizeQuestionSetPanelArrangement(
    raw: string | undefined,
): QuestionSetPanelArrangement {
    if (raw === 'vertical') {
        return 'vertical';
    }
    return 'horizontal';
}

/**
 * Full layout row with `type` coerced for question-set (auto → horizontal).
 */
export function normalizeQuestionSetLayoutConfig(
    layout: QuestionSetLayoutConfig | undefined | null,
): QuestionSetLayoutConfig & { type: QuestionSetPanelArrangement } {
    const base = (layout ?? {}) as Partial<QuestionSetLayoutConfig>;
    const type = normalizeQuestionSetPanelArrangement(base.type as string | undefined);
    return {
        ...(base as QuestionSetLayoutConfig),
        type,
    };
}
